import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { initializeEventListeners } from "@components/Common/Function";

/**
 * Custom hook to initialize event listeners for session management
 * Handles token expiry monitoring and cleanup
 * 
 * @returns {Object} Redux dispatch and expiryTime for use in components
 */
export const usePageInitialization = () => {
  const dispatch = useDispatch();
  const expiryTime = useSelector((state) => state?.tokens?.creationDate);
  const eventCountRef = useRef(0);
  const hasEventListeners = useRef(false);

  useEffect(() => {
    const cleanup = initializeEventListeners(
      expiryTime,
      dispatch,
      eventCountRef,
      hasEventListeners
    );
    return cleanup;
  }, [expiryTime, dispatch]);

  return { dispatch, expiryTime };
};
